function addStarToAuthor(editor) {
  if (!editor?.dom) return;

  const contribs = editor.dom.select("contrib[corresp='yes']");
  const corresps = editor.dom.select("corresp");

  contribs.forEach((contrib) => {
    const surnameEl = editor.dom.select("surname", contrib)[0];
    const givenEl = editor.dom.select("given-names", contrib)[0];
    const nameEl = editor.dom.select("name", contrib)[0];

    if (!surnameEl || !givenEl || !nameEl) return;

    const fullName =
      `${givenEl.textContent.trim()} ${surnameEl.textContent.trim()}`
        .replace(/\s+/g, " ")
        .trim();

    const matchedCorresp = corresps.find((corresp) =>
      corresp.textContent.replace(/\s+/g, " ").includes(fullName)
    );

    if (matchedCorresp) {
      // Check if <sup> already exists inside <name>
      const existingSup = editor.dom.select("sup", nameEl)[0];
      if (existingSup) return;

      // Create <sup style="color:red">*</sup>
      const sup = editor.dom.create(
        "sup",
        {
          style:
            "padding-right: 5px;color:red;font-size: 18px;vertical-align: baseline;",
        },
        "*"
      );
      sup.setAttribute("data-edit", "corresponding");
      nameEl.appendChild(sup);
    }
  });
}

function extractPreciseXrefs(editor) {
  if (!editor?.dom) return [];

  const xrefData = [];
  const main = editor.dom.select("body1")[0];
  const xrefs = main && main.querySelectorAll("xref"); 

  if (!xrefs) return [];

  xrefs.forEach((xref) => {
    const verticalAlign = editor.dom.getStyle(xref, "vertical-align");
    if (verticalAlign === "super") return;
    const number = xref.textContent.trim();
    const key = xref.getAttribute("key");
    const rid = xref.getAttribute("rid");

    // Only keep rid values like 'ref-1', 'ref-23', etc.
    // if (!/^ref-\d+$/.test(rid)) return;

    let beforeText = "";

    // Traverse backward from the xref to collect preceding text
    let node = xref.previousSibling;
    while (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        beforeText = node.textContent + beforeText;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        break; 
      }
      node = node.previousSibling;
    }

    xrefData.push({
      number,
      key,
      rid,
      beforeText: beforeText.trim(),
    });
  });

  return xrefData;
}


function scrollToXrefByKey(editorRef, key) {
  const editor = editorRef?.current?.editor;

  if (!editor) {
    console.warn("Editor not available");
    return;
  }

  const dom = editor.dom;
  const xrefEl = dom.select(`xref[key="${key}"]`)[0];

  console.log(xrefEl, "xref element");

  if (!xrefEl) {
    console.warn(`xref with key="${key}" not found`);
    return;
  }

  dom.removeClass(dom.select("xref"), "highlighted-xref");
  dom.addClass(xrefEl, "highlighted-xref");

  xrefEl.scrollIntoView({ behavior: "smooth", block: "center" });
}

export { addStarToAuthor, scrollToXrefByKey, extractPreciseXrefs };
